import { computed } from 'vue'
import { useMediaQuery } from '@vueuse/core'

const MOBILE_UA = /iPhone|iPad|iPod|Android|webOS|BlackBerry|IEMobile|Opera Mini/i

export function useDevice() {
  // Viewport-based: drives layout decisions (small screen vs not).
  const isSmallScreen = useMediaQuery('(max-width: 767px)')

  // UA-based: can this device actually run our desktop binaries?
  const isMobileDevice = computed(() => {
    if (typeof navigator === 'undefined') return false
    return MOBILE_UA.test(navigator.userAgent)
  })

  // Hide desktop download CTAs on phones/tablets — they can't install the app.
  const canRunDesktopApp = computed(() => !isMobileDevice.value)

  type DesktopOs = 'windows' | 'macos' | 'linux'
  const desktopOs = computed<DesktopOs | null>(() => {
    if (typeof navigator === 'undefined') return null
    if (isMobileDevice.value) return null
    const ua = navigator.userAgent.toLowerCase()
    if (ua.includes('mac os x') || ua.includes('macintosh')) return 'macos'
    if (ua.includes('linux')) return 'linux'
    if (ua.includes('windows')) return 'windows'
    return null
  })

  return { isSmallScreen, isMobileDevice, canRunDesktopApp, desktopOs }
}
